(() => {
  const dataEl = document.getElementById('ly-data');
  if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (c) => '$' + (Math.round(c) / 100).toFixed(2);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const ease = (a, b, v) => { const t = clamp((v - a) / (b - a)); return t * t * (3 - 2 * t); };

  /* Drifting leaves & pollen */
  const air = $('.ly-air');
  if (air && !reduced) {
    const cols = ['#A7B49A', '#C8A27C', '#D9C7AD', '#B9C4AC'];
    const n = innerWidth < 600 ? 10 : 18;
    for (let i = 0; i < n; i++) {
      const f = document.createElement('i');
      f.style.cssText = `left:${Math.random() * 100}%;--s:${(5 + Math.random() * 9).toFixed(1)}px;--o:${(0.25 + Math.random() * 0.35).toFixed(2)};--d:${(16 + Math.random() * 16).toFixed(1)}s;--dl:${(-Math.random() * 30).toFixed(1)}s;--x:${(Math.random() * 120 - 60).toFixed(0)}px;--c:${cols[i % cols.length]}`;
      air.appendChild(f);
    }
  }

  /* Gallery */
  const track = $('.ly-gallery__track');
  if (track) {
    const slides = $$('.ly-gallery__slide', track);
    const thumbs = $$('.ly-thumbs button');
    const dots = $$('.ly-gallery__dots span');
    const thumbBar = $('.ly-thumbs');
    let cur = 0;
    const go = (i) => { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' }); };
    const mark = (i, init) => {
      cur = i;
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
      dots.forEach((t, k) => t.classList.toggle('is-on', k === i));
      const t = thumbs[i];
      if (!init && t && thumbBar && thumbBar.scrollWidth > thumbBar.clientWidth) thumbBar.scrollTo({ left: t.offsetLeft - thumbBar.offsetLeft - 40, behavior: 'smooth' });
    };
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur && i >= 0 && i < slides.length) mark(i); });
    }, { passive: true });
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const prev = $('.ly-gallery__arrow--prev');
    const next = $('.ly-gallery__arrow--next');
    if (prev) prev.addEventListener('click', () => go(cur - 1));
    if (next) next.addEventListener('click', () => go(cur + 1));
    mark(0, true);
  }

  /* Bundles + add-ons */
  const state = { variant: null };
  const update = () => {
    const r = $('input[name="ly-bundle"]:checked');
    if (!r) return;
    const v = D.variants.find((x) => String(x.id) === r.value);
    if (!v) return;
    state.variant = v;
    $$('.ly-bundle').forEach((b) => b.classList.toggle('is-on', b.contains(r)));
    $$('.ly-addon').forEach((a) => a.classList.toggle('is-on', $('input', a).checked));
    let total = v.price;
    $$('.ly-addon input:checked').forEach((i) => { const a = D.addons[i.value]; if (a) total += a.sale; });
    $$('[data-ly-now]').forEach((e) => (e.textContent = money(v.price)));
    const was = $('[data-ly-was]');
    const save = $('[data-ly-save]');
    if (was && save) {
      if (v.compare > v.price) { was.hidden = false; was.textContent = money(v.compare); save.hidden = false; save.textContent = 'You save ' + money(v.compare - v.price); }
      else { was.hidden = true; save.hidden = true; }
    }
    $$('[data-ly-total]').forEach((e) => (e.textContent = money(total)));
    $$('[data-ly-sticky-t]').forEach((e) => (e.textContent = 'Lymphoria · ' + v.title));
  };
  $$('input[name="ly-bundle"], .ly-addon input').forEach((i) => i.addEventListener('change', update));
  update();

  /* Supply cards pick a bundle */
  $$('[data-ly-pick]').forEach((a) => a.addEventListener('click', () => {
    const r = $(`input[name="ly-bundle"][value="${a.dataset.lyPick}"]`);
    if (r && !r.disabled) { r.checked = true; update(); }
  }));

  /* Delivery estimate */
  const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const plus = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
  $$('[data-ly-arrive]').forEach((e) => (e.textContent = fmt(plus(D.shipMin)) + ' – ' + fmt(plus(D.shipMax))));

  /* Cart */
  const api = (u, b) => fetch(root + u, b ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) } : { headers: { Accept: 'application/json' } })
    .then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; });
  const getCart = () => api('cart.js');
  const drawer = $('.ly-drawer');
  const setCount = (c) => $$('[data-ly-count]').forEach((e) => { e.textContent = c.item_count; e.hidden = !c.item_count; });
  const imgUrl = (u) => u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
  const render = (c) => {
    setCount(c);
    const body = $('.ly-drawer__body', drawer);
    const checkout = $('[data-ly-checkout]', drawer);
    if (!c.items.length) {
      body.innerHTML = '<p class="ly-drawer__empty">Your cart is empty</p>';
    } else {
      body.innerHTML = c.items.map((it) => {
        const img = it.image ? `<img src="${esc(imgUrl(it.image))}" alt="" width="64" height="64" loading="lazy">` : '<span class="ly-line__ph" aria-hidden="true">🌿</span>';
        const vt = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '';
        const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
        const k = esc(it.key);
        return `<div class="ly-line"><div>${img}</div><div><p class="ly-line__t">${esc(it.product_title)}</p><p class="ly-line__v">${vt}</p><div class="ly-line__qty"><button type="button" data-q="${it.quantity - 1}" data-k="${k}" aria-label="Decrease quantity">−</button><span>${it.quantity}</span><button type="button" data-q="${it.quantity + 1}" data-k="${k}" aria-label="Increase quantity">+</button></div><button type="button" class="ly-line__rm" data-q="0" data-k="${k}">Remove</button></div><div class="ly-line__p">${was}${money(it.final_line_price)}</div></div>`;
      }).join('');
      const hasMain = c.items.some((i) => String(i.product_id) === String(D.productId));
      const ids = c.items.map((i) => String(i.variant_id));
      const ups = hasMain ? Object.values(D.addons).filter((a) => ids.indexOf(String(a.id)) === -1) : [];
      if (ups.length) body.insertAdjacentHTML('beforeend', '<div class="ly-up">' + ups.map((a) => `<div class="ly-up__item"><span aria-hidden="true">${a.icon}</span><div><b>${esc(a.title)}</b>${money(a.sale)}</div><button type="button" data-add="${a.id}">Add</button></div>`).join('') + '</div>');
    }
    $('[data-ly-subtotal]', drawer).textContent = money(c.total_price);
    const saveRow = $('[data-ly-saverow]', drawer);
    let saved = 0;
    c.items.forEach((i) => { const v = D.variants.find((x) => String(x.id) === String(i.variant_id)); if (v && v.compare > v.price) saved += (v.compare - v.price) * i.quantity; saved += i.original_line_price - i.final_line_price; });
    saveRow.hidden = saved <= 0;
    $('[data-ly-saved]', drawer).textContent = '−' + money(saved);
    checkout.toggleAttribute('aria-disabled', !c.items.length);
    checkout.style.pointerEvents = c.items.length ? '' : 'none';
    checkout.style.opacity = c.items.length ? '' : '.5';
  };
  let lastFocus = null;
  const openDrawer = () => { lastFocus = document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const b = $('[data-ly-close].ly-ico', drawer); if (b) b.focus(); };
  const closeDrawer = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); };
  $$('[data-ly-open-cart]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); getCart().then(render).catch(() => {}); openDrawer(); }));
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-ly-close]')) { closeDrawer(); return; }
    const q = e.target.closest('[data-q]');
    if (q) { q.disabled = true; api('cart/change.js', { id: q.dataset.k, quantity: Math.max(0, +q.dataset.q) }).then(render).catch((err) => { q.disabled = false; alert(err.message); }); return; }
    const a = e.target.closest('[data-add]');
    if (a) { a.disabled = true; a.textContent = 'Adding…'; api('cart/add.js', { items: [{ id: +a.dataset.add, quantity: 1 }] }).then(getCart).then(render).catch((err) => { a.disabled = false; a.textContent = 'Add'; alert(err.message); }); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  const errEl = $('[data-ly-error]');
  const addToCart = async (btn, toCheckout) => {
    const v = state.variant;
    if (!v || btn.disabled) return;
    if (errEl) errEl.hidden = true;
    const label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = toCheckout ? 'Going to checkout…' : 'Adding…';
    try {
      const c = await getCart();
      const inCart = c.items.map((i) => String(i.variant_id));
      const items = [{ id: v.id, quantity: 1 }];
      $$('.ly-addon input:checked').forEach((i) => { const a = D.addons[i.value]; if (a && inCart.indexOf(String(a.id)) === -1) items.push({ id: a.id, quantity: 1 }); });
      await api('cart/add.js', { items });
      if (toCheckout) { window.location.href = root + 'checkout'; return; }
      render(await getCart());
      openDrawer();
    } catch (e) {
      if (errEl) { errEl.textContent = e.message || 'Something went wrong. Please try again.'; errEl.hidden = false; }
    }
    btn.disabled = false;
    btn.innerHTML = label;
    update();
  };
  $$('[data-ly-add]').forEach((b) => b.addEventListener('click', () => addToCart(b, false)));
  $$('[data-ly-buy]').forEach((b) => b.addEventListener('click', () => addToCart(b, true)));
  getCart().then(setCount).catch(() => {});
  window.addEventListener('pageshow', (e) => { if (e.persisted) getCart().then(setCount).catch(() => {}); });

  /* Sticky add-to-cart */
  const sticky = $('.ly-sticky');
  const atc = $('#ly-atc');
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); }).observe(atc);
  }

  /* Reveal on scroll */
  const rev = $$('.ly-reveal');
  if ('IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    rev.forEach((el) => io.observe(el));
  } else rev.forEach((el) => el.classList.add('is-in'));

  /* Scroll-driven scenes */
  const drop = $('[data-ly-drop]');
  const steps = drop ? $$('.ly-drop__steps li', drop) : [];
  const ritual = $('[data-ly-ritual]');
  const band = $('[data-ly-band]');
  const pars = $$('[data-ly-par]');
  const setDrop = (p) => {
    const s = drop.style;
    s.setProperty('--p', p.toFixed(3));
    s.setProperty('--lift', Math.sin(clamp(p / 0.2) * Math.PI).toFixed(3));
    s.setProperty('--show', p > 0.04 ? '1' : '0');
    s.setProperty('--fall', ease(0.2, 0.46, p).toFixed(3));
    s.setProperty('--gone', p > 0.47 ? '1' : '0');
    s.setProperty('--rip', clamp((p - 0.46) / 0.22).toFixed(3));
    s.setProperty('--tint', ease(0.48, 0.86, p).toFixed(3));
    const st = p < 0.24 ? 0 : p < 0.56 ? 1 : 2;
    steps.forEach((li, i) => li.classList.toggle('is-on', i === st));
  };
  if (drop && reduced) setDrop(1);
  let bandX = 0, lastY = scrollY, bandW = 0, ticking = false;
  const measureBand = () => { if (band) bandW = band.scrollWidth / 3; };
  measureBand();
  addEventListener('resize', measureBand);
  const frame = () => {
    ticking = false;
    const vh = innerHeight;
    if (drop && !reduced) {
      const r = drop.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) setDrop(clamp(-r.top / (r.height - vh)));
    }
    if (ritual) {
      const r = ritual.getBoundingClientRect();
      ritual.style.setProperty('--p', clamp((vh * 0.75 - r.top) / r.height).toFixed(3));
    }
    if (!reduced) {
      pars.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        const c = r.top + r.height / 2 - vh / 2;
        el.style.transform = `translate3d(0, ${(c * -parseFloat(el.dataset.lyPar)).toFixed(1)}px, 0)`;
      });
    }
  };
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  frame();

  /* Word band: drifts on its own and speeds up with scrolling */
  if (band && !reduced) {
    let boost = 0;
    const loop = () => {
      const dy = scrollY - lastY; lastY = scrollY;
      boost = boost * 0.9 + Math.abs(dy) * 0.12;
      bandX -= 0.5 + boost;
      if (bandW && -bandX > bandW) bandX += bandW;
      band.style.transform = `translate3d(${bandX.toFixed(1)}px,0,0)`;
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  /* Gentle 3D tilt on the "ways" cards */
  if (!reduced && matchMedia('(hover: hover)').matches) {
    $$('[data-ly-tilt]').forEach((c) => {
      c.addEventListener('pointermove', (e) => {
        const r = c.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = `rotateY(${(x * 10).toFixed(2)}deg) rotateX(${(-y * 10).toFixed(2)}deg) translateY(-4px)`;
      });
      c.addEventListener('pointerleave', () => { c.style.transform = ''; });
    });
  }

  /* Drag to scroll the herb cards with a mouse */
  $$('[data-ly-drag]').forEach((el) => {
    let down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; el.classList.add('is-drag'); });
    addEventListener('pointerup', () => { if (down) { down = false; el.classList.remove('is-drag'); } });
    el.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 3) moved = true; el.scrollLeft = sl - dx; });
    el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });
})();
